// Forked from api/msw/api/caseNotes/index.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getServiceRequestNoteListData } from './mockData'
import type { IServiceRequestNote } from '~/types/note/models'

export const {
  getNotes: getServiceRequestNotes,
  postNote: postServiceRequestNote,
  patchNote: patchServiceRequestNote,
  deleteNote: deleteServiceRequestNote,
  handlers,
} = makeNoteAPIs<IServiceRequestNote>({
  apiPathEntityNamePrefix: 'serviceRequest',
  getNoteListDataFn: getServiceRequestNoteListData,
})
